import { Component, OnInit } from '@angular/core';
import { AppService } from './../appservice.service';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-activate',
  templateUrl: './activate.component.html',
  styleUrls: ['./activate.component.css']
})
export class ActivateComponent implements OnInit {
  year = (new Date()).getFullYear();

  loading = false;
  gstpattern = '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$';
  panpattern = '^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$';
  mobilepattern = '^(?:(?:\\+|0{0,2})91(\\s*[\\ -]\\s*)?|[0]?)?[56789]\\d{9}|(\\d[ -]?){10}\\d$';
  isoffline = false;

  myGroup = new FormGroup({
    code: new FormControl(),
    orgname: new FormControl(),
    mobile: new FormControl('', [Validators.pattern(this.mobilepattern)]),
    email: new FormControl(),
    address: new FormControl(),
    address2: new FormControl(),
    city: new FormControl(),
    state: new FormControl(),
    pan: new FormControl('', [Validators.pattern(this.panpattern)]),
    gstin: new FormControl('', [Validators.pattern(this.gstpattern)]),
    isnew: new FormControl(this.service.isnew),
    isoffline: new FormControl(''),
    offlineresponse: new FormControl('')
  });

  constructor(public translate: TranslateService, public service: AppService) { translate.setDefaultLang('en'); }

  ngOnInit() {
  }

  onSubmit() {
    this.myGroup.value.isoffline = false;
    this.myGroup.value.isnew = this.service.isnew;
    this.isoffline = false;
    if (this.myGroup.valid) {
      this.loading = true;
      this.service.sendMessage('Activating... please will take 2-3 minutes.');
      setTimeout(() => {
        this.loading = false;
      }, 25000);
      this.service.activate(this.myGroup.value);
    }
  }

  Activate2() {
    this.myGroup.value.isnew = this.service.isnew;
    this.myGroup.value.isoffline = true;
    this.isoffline = true;
    if (this.myGroup.valid) {
      this.loading = true;
      this.service.sendMessage('Activating... please will take 2-3 minutes.');
      setTimeout(() => {
        this.loading = false;
      }, 25000);
      this.service.activate(this.myGroup.value);
    }
  }

}
